export default __webpack_public_path__ + "static/media/facebook (1)@1.5x.19b6ca39.svg";